var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-mobile arrobita-no-data"},[_c('div',{staticClass:"column column-container"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"arrobita-no-data__message is-size-6-touch"},[_vm._v(" "+_vm._s(_vm.message))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }